<template>
<!-- 司机-司机任务-黑名单 -->
    <el-dialog :visible.sync="show" :close-on-click-modal="false" append-to-body width="95%" :before-close="closeDialog">
        <div>
            <div style="font-weight: 700; font-size: 20px; text-align: center; margin-bottom: 20px">
                黑名单列表
            </div>
            <div class="handle-box-search">
                <div class="handle-box">
                    <el-row class="head-search">
                        <el-col :span="12">
                            <span class="title">司机姓名:</span>
                            <!-- 搜索司机姓名 -->
                            <el-input
                                v-model="search_data.driver_name"
                                placeholder="请输入司机姓名"
                                class="handle-input mr10"
                                @keyup.enter.native="searchBlackList"
                            ></el-input>
                        </el-col>
                        <el-col :span="12">
                            <span class="title">司机电话号:</span>

                            <el-input
                                v-model="search_data.driver_phone"
                                placeholder="请输入司机电话号"
                                class="handle-input mr10"
                                @keyup.enter.native="searchBlackList"
                            ></el-input>
                        </el-col>
                    </el-row>
                </div>

                <el-button type="primary" icon="el-icon-search" @click="searchBlackList">搜索</el-button>
                <el-button type="primary" @click="addDriver">添加黑名单司机</el-button>
                <span style="margin-left: 10px">黑名单</span>
                <!-- <el-tooltip class="item" effect="dark" content="黑名单司机不会接到该模式订单" placement="right">
                    <i class="el-icon-question"></i>
                </el-tooltip> -->
           
            </div>
        </div>
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column prop="real_name" label="司机姓名" min-width="80"> </el-table-column>

            <el-table-column prop="phone" label="司机电话" min-width="60"> </el-table-column>

            <el-table-column prop="time_stamp" label="添加时间" min-width="80"> </el-table-column>

            <el-table-column width="150" label="操作">
                <template slot-scope="scope">
                    <el-button type="danger" trigger="click" @click="deletePromotionQR(scope.row)"> 移除黑名单 </el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- element ui 原生分页组件 -->
        <div class="pagination">
            <el-pagination
                v-if="result_data.count"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="search_data.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="search_data.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="result_data.count"
            >
            </el-pagination>
        </div>
        <!-- 黑名单组件 -->
        <addDriver :isShow="add_list_show" :data="driverListDate" @onSubmit="searchBlackList"></addDriver>
    </el-dialog>
</template>

<script>
let _this;
import addDriver from './addDriver.vue';
export default {
    components: {
        addDriver
    },
    props: {
        isShow: Boolean,
        data: {}
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;

            _this.search_data.driver_task_code = _this.data.driver_task_code;
    
            _this.searchBlackList();
        }
    },
    created() {
        _this = this;
    },
    data() {
        return {
            show: false,
            driverListDate: {},
            add_list_show: false,
            search_data: {
                page: 1,
                limit: 10,
                driver_task_code: '',
          
            },

            tableData: [],
            result_data: {}
        };
    },
    methods: {
        addDriver() {
           
            _this.add_list_show = !_this.add_list_show;


            _this.driverListDate.driver_task_code = _this.data.driver_task_code;
        },
        deletePromotionQR(val) {
            this.$confirm('您确认要将该司机移除黑名单吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    _this
                        .$post('/task_new/delDriver', {
                            id: val.id,
                          
                        })
                        .then((res) => {
                            _this.$message.success(res.msg);
                            _this.searchBlackList();
                        })
                        .catch((err) => {});
                })
                .catch(() => {
                    _this.searchBlackList();
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
        },

        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.tableData = [];
            _this.driverListDate= {};
            _this.result_data= {};

            _this.search_data = {
                page: 1,
                limit: 10,
                driver_task_code: '',
 
            };
        },

       
        blackList() {
            console.log(_this.search_data,'_this.search_data');
            _this.$post('/task_new/blackList', _this.search_data).then((res) => {
                _this.result_data = res;
                _this.tableData = res.data;
            });
        },

        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
            // console.log(val, 'val');
            _this.search_data.limit = val;

            //初始化列表
            _this.pages_function();
        },
        //页码变化
        handleCurrentChange(val) {
            _this.search_data.page = val;
            //初始化列表
            _this.pages_function();
        },
        //翻页组件的回调
        pages_function() {
            //初始化列表
            _this.blackList();
        },
        searchBlackList() {
            _this.search_data.page = 1;
            _this.blackList();
        }
    }
};
</script>

<style scoped>
.pagination {
    text-align: right;
}
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>
